import { jsx as _jsx } from "react/jsx-runtime";
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '../Typography';
const CustomFormControlLabel = ({ label, ...rest }) => (_jsx(FormControlLabel, { label: _jsx(Typography.Paragraph, { children: label }), ...rest }));
export { CustomFormControlLabel };
